import { Styles } from "./styled";

interface IProps {
  label?: string;
  value?: number | string;
}

const SummaryItem = (props: IProps) => {
  const { label, value } = props;
  return (
    <Styles>
      <span className="label-summary">{label}</span>
      <span className="value-summary">{value}</span>
    </Styles>
  );
};
export default SummaryItem;
